<template>

  <!-- Content
  ============================================= -->
  <section id="content">

    <div class="content-wrap">

      <div id="section-contact" class="page-section container-fluid clearfix">

        <h2 class="bottommargin">Get in Touch</h2>

        <div class="row clearfix">

          <div class="col-md-8">
            <h4>Located in Central Massachusetts, USA</h4>
            <hr>
            <div style="font-size: 16px; line-height: 1.7;">
              <p>If you are interested in getting in touch for consulting sessions or projects please use the button below to get in touch.</p>

              <div class="clear topmargin"></div>

              <a href="mailto:terri.ann.s@gmail.com" class="button button-3d button-xlarge button-rounded button-dirtygreen">Email Me</a>

            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
</template>


<script>

export default {
  name: 'contact',
  components: {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// contact.vue?7a79e322